var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _g, _g2, _g3, _g4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBrand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 250 250",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.899 88.274c-.161-7.147-1.09-16.923.508-25.248 1.323-6.892 4.483-12.778 12.546-13.892a4.002 4.002 0 003.414-4.51 4.002 4.002 0 00-4.51-3.415c-12.07 1.668-17.326 9.992-19.306 20.309-1.705 8.882-.821 19.311-.65 26.936a4.001 4.001 0 007.998-.18z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55.507,
    cy: 423.077,
    r: 20.105,
    fill: "#af0018",
    stroke: "#000",
    transform: "translate(20.224 -253.854)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.507,
    cy: 423.077,
    r: 20.105,
    fill: "#af0018",
    stroke: "#000",
    transform: "translate(38.224 -270.854)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.507,
    cy: 423.077,
    r: 20.105,
    fill: "#af0018",
    stroke: "#000",
    transform: "translate(3.224 -270.854)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.507,
    cy: 423.077,
    r: 20.105,
    fill: "#af0018",
    stroke: "#000",
    transform: "translate(-10.776 -300.854)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.507,
    cy: 423.077,
    r: 20.105,
    fill: "#af0018",
    stroke: "#000",
    transform: "translate(47.224 -300.854)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.507,
    cy: 423.077,
    r: 20.105,
    fill: "#af0018",
    stroke: "#000",
    transform: "translate(36.224 -330.854)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.507,
    cy: 423.077,
    r: 20.105,
    fill: "#af0018",
    stroke: "#000",
    transform: "translate(3.224 -330.854)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.507,
    cy: 423.077,
    r: 20.105,
    fill: "#af0018",
    stroke: "#000",
    transform: "translate(20.224 -300.854)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M144.899 49.274c-.161-7.147-1.09-16.923.508-25.248 1.323-6.892 4.483-12.778 12.546-13.892a4.002 4.002 0 003.414-4.51 4.002 4.002 0 00-4.51-3.415c-12.07 1.668-17.326 9.992-19.306 20.309-1.705 8.882-.821 19.311-.65 26.936a4.001 4.001 0 007.998-.18z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.507,
    cy: 423.077,
    r: 20.105,
    fill: "#2e00ff",
    stroke: "#000",
    transform: "translate(86.224 -292.854)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.507,
    cy: 423.077,
    r: 20.105,
    fill: "#2e00ff",
    stroke: "#000",
    transform: "translate(104.224 -309.854)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.507,
    cy: 423.077,
    r: 20.105,
    fill: "#2e00ff",
    stroke: "#000",
    transform: "translate(69.224 -309.854)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.507,
    cy: 423.077,
    r: 20.105,
    fill: "#2e00ff",
    stroke: "#000",
    transform: "translate(55.224 -339.854)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.507,
    cy: 423.077,
    r: 20.105,
    fill: "#2e00ff",
    stroke: "#000",
    transform: "translate(113.224 -339.854)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.507,
    cy: 423.077,
    r: 20.105,
    fill: "#2e00ff",
    stroke: "#000",
    transform: "translate(102.224 -369.854)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.507,
    cy: 423.077,
    r: 20.105,
    fill: "#2e00ff",
    stroke: "#000",
    transform: "translate(69.224 -369.854)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.507,
    cy: 423.077,
    r: 20.105,
    fill: "#2e00ff",
    stroke: "#000",
    transform: "translate(86.224 -339.854)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M181.437 125.34c-.161-7.147-1.09-16.923.508-25.248 1.323-6.892 4.483-12.778 12.546-13.892a4.002 4.002 0 003.414-4.51 4.002 4.002 0 00-4.51-3.415c-12.069 1.668-17.326 9.992-19.306 20.309-1.705 8.882-.821 19.311-.65 26.936a4.001 4.001 0 007.998-.18z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.507,
    cy: 423.077,
    r: 20.105,
    fill: "#009e16",
    stroke: "#000",
    transform: "translate(122.762 -216.788)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.507,
    cy: 423.077,
    r: 20.105,
    fill: "#009e16",
    stroke: "#000",
    transform: "translate(140.762 -233.788)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.507,
    cy: 423.077,
    r: 20.105,
    fill: "#009e16",
    stroke: "#000",
    transform: "translate(105.762 -233.788)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.507,
    cy: 423.077,
    r: 20.105,
    fill: "#009e16",
    stroke: "#000",
    transform: "translate(91.762 -263.788)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.507,
    cy: 423.077,
    r: 20.105,
    fill: "#009e16",
    stroke: "#000",
    transform: "translate(149.762 -263.788)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.507,
    cy: 423.077,
    r: 20.105,
    fill: "#009e16",
    stroke: "#000",
    transform: "translate(138.762 -293.788)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.507,
    cy: 423.077,
    r: 20.105,
    fill: "#009e16",
    stroke: "#000",
    transform: "translate(105.762 -293.788)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.507,
    cy: 423.077,
    r: 20.105,
    fill: "#009e16",
    stroke: "#000",
    transform: "translate(122.762 -263.788)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M118.899 146.274c-.161-7.147-1.09-16.923.508-25.248 1.323-6.892 4.483-12.778 12.546-13.892a4.002 4.002 0 003.414-4.51 4.002 4.002 0 00-4.51-3.415c-12.07 1.668-17.326 9.992-19.306 20.309-1.705 8.882-.821 19.311-.65 26.936a4.001 4.001 0 007.998-.18z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.507,
    cy: 423.077,
    r: 20.105,
    fill: "#5c00ff",
    stroke: "#000",
    transform: "translate(60.224 -195.854)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.507,
    cy: 423.077,
    r: 20.105,
    fill: "#5c00ff",
    stroke: "#000",
    transform: "translate(78.224 -212.854)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.507,
    cy: 423.077,
    r: 20.105,
    fill: "#5c00ff",
    stroke: "#000",
    transform: "translate(43.224 -212.854)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.507,
    cy: 423.077,
    r: 20.105,
    fill: "#5c00ff",
    stroke: "#000",
    transform: "translate(29.224 -242.854)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.507,
    cy: 423.077,
    r: 20.105,
    fill: "#5c00ff",
    stroke: "#000",
    transform: "translate(87.224 -242.854)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.507,
    cy: 423.077,
    r: 20.105,
    fill: "#5c00ff",
    stroke: "#000",
    transform: "translate(76.224 -272.854)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.507,
    cy: 423.077,
    r: 20.105,
    fill: "#5c00ff",
    stroke: "#000",
    transform: "translate(43.224 -272.854)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.507,
    cy: 423.077,
    r: 20.105,
    fill: "#5c00ff",
    stroke: "#000",
    transform: "translate(60.224 -242.854)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.602 56.93l6.39-4.038c2.477.849 4.286 2.214 5.482 4.107 1.389 2.198 1.752 4.571 1.103 7.063-.683 2.513-2.187 4.552-4.52 6.026-3.078 1.944-6.43 2.406-10.013 1.452-3.604-.987-6.481-3.144-8.575-6.458-2.115-3.348-2.772-6.86-1.997-10.425.755-3.6 2.755-6.425 6.035-8.497 1.116-.705 2.483-1.238 4.113-1.652l4.23 6.695c-1.347.19-2.498.538-3.344 1.072-1.59 1.004-2.554 2.323-2.915 3.924-.395 1.621-.112 3.193.871 4.749 1.026 1.623 2.29 2.575 3.835 2.924 1.49.336 3.04.019 4.595-.964 1.015-.641 1.351-1.232.967-1.84-.278-.44-.744-.43-1.42-.002l-1.59 1.004-3.247-5.14zM38.822 40.467l4.188 6.628c-.577-.014-1.047.14-1.385.354-1.15.727-1.157 1.914-.067 3.639l4.935 7.811-6.188 3.91-5.683-8.995c-1.496-2.367-2.05-4.667-1.628-6.92.388-2.233 1.697-4.054 3.862-5.421.473-.3 1.158-.637 1.966-1.006zM48.347 34.213c2.333-1.474 4.862-1.889 7.6-1.3 2.725.644 4.852 2.139 6.327 4.472 1.495 2.367 1.932 4.93 1.309 7.69-.644 2.725-2.173 4.873-4.54 6.369-2.4 1.517-4.964 1.953-7.723 1.33-2.738-.588-4.899-2.062-6.394-4.429-1.517-2.401-1.92-4.985-1.276-7.71.644-2.726 2.228-4.862 4.697-6.422zm3.676 6.194a2.753 2.753 0 00-1.242 1.779c-.12.784.007 1.509.435 2.185.448.71 1.048 1.136 1.82 1.31.773.174 1.485.103 2.128-.303a2.662 2.662 0 001.22-1.812c.175-.773.048-1.497-.4-2.207-.428-.676-1.028-1.102-1.788-1.331a2.777 2.777 0 00-2.173.38zM59.788 27.79l6.188-3.91 5.876 9.3c.598.946 1.247 1.15 2.059.638.744-.47.872-1.166.274-2.113l-5.875-9.3 6.154-3.888 5.811 9.198c1.346 2.13 1.769 4.372 1.267 6.723-.48 2.385-1.735 4.219-3.798 5.522-2.333 1.474-4.782 1.792-7.27.998-1.95-.614-3.7-2.11-5.195-4.478l-5.491-8.69zM97.984 34.886l-6.189 3.91-8.674-13.73c-1.602-2.536-2.208-4.993-1.893-7.415a9.794 9.794 0 011.52-4.036 9.934 9.934 0 013.072-3.076c2.468-1.56 5.065-2.017 7.803-1.429 2.716.555 4.843 2.05 6.36 4.451 1.474 2.334 1.91 4.897 1.322 7.634-.623 2.76-2.084 4.865-4.35 6.297-.371.235-.968.564-1.72.945L90.94 21.64c.764.085 1.4-.032 1.907-.353a2.517 2.517 0 001.174-1.735 2.753 2.753 0 00-.358-2.14c-.406-.642-1.006-1.068-1.757-1.208-.773-.174-1.476-.014-2.152.413-1.555.983-1.683 2.578-.295 4.776l8.525 13.493z",
    fillRule: "nonzero"
  }))));
}

export default SvgBrand;